import { CheckCircle, Prohibit, ShieldWarning, WarningCircle } from "@phosphor-icons/react";
import { text } from "../i18n.js";
import type { Locale, SupportStatus } from "../types.js";

const icons = {
  verified: CheckCircle,
  "needs-reverification": WarningCircle,
  incompatible: Prohibit,
  yanked: ShieldWarning,
} satisfies Record<SupportStatus, typeof CheckCircle>;

export function StatusBadge({ locale, status, withHelp = false }: {
  readonly locale: Locale;
  readonly status: SupportStatus;
  readonly withHelp?: boolean;
}) {
  const t = text(locale);
  const Icon = icons[status];
  return (
    <span className={`status status-${status}`} title={withHelp ? t.statusHelp[status] : undefined}>
      <Icon aria-hidden="true" weight="bold" />
      {t.status[status]}
    </span>
  );
}
